import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';

import TextInput from 'common/TextInput';

const baseString = 'vra-active-seed-product-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
const ActiveSeedProductInputs = ({
  activeSeedProductsByInput,
  onClickRemoveActiveProductTrigger
}) => {
  const inputs = Object.keys(activeSeedProductsByInput).map((selectId) => {
    const select = activeSeedProductsByInput[selectId];
    const id = get(select, 'id');
    const brand = get(select, 'brand');
    const name = get(select, 'name');

    if (id) {
      return (
        <TextInput
          onReset={() => { onClickRemoveActiveProductTrigger(selectId); }}
          readOnly
          showReset={true}
          value={`${brand} ${name}`}
        />
      );
    }

    return null;
  });

  return (
    <section className={classString}>
      {inputs}
    </section>
  );
};
ActiveSeedProductInputs.propTypes = {
  activeSeedProductsByInput: PropTypes.object.isRequired,
  onClickRemoveActiveProductTrigger: PropTypes.func.isRequired
};
export default ActiveSeedProductInputs;
